import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend
);

const BarChart = ({ data }) => {
  const [successCount, failedCount, partialsuccesscount] = data;

    const chartData = {
      labels: [`Success (${successCount})`, `Failed (${failedCount})`, `Partial Success (${partialsuccesscount})`],
      datasets: [
        {
          label: 'Number of Files',
          data: data,
          backgroundColor: ['#4caf50', '#dc3545', '#fd7e14'],
        },
      ],
    };
  
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: false, // Disable the legend
          
        },
        title: {
          display: true,
          text: 'File Upload Status',
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: 'Document Status',
          },
        },
        y: {
          title: {
            display: true,
            text: '# of Documents',
          },
        },
      },
    };
  
    return <Bar data={chartData} options={options} />;
  };
  

export default BarChart;